import colors from 'styles/colors';
import { CloseButtonProps } from './CloseButton.types';
import CloseIcon from 'components/svg/CloseIcon';
import { Button } from './CloseButton.styled';

const CloseButton = ({onClick}: CloseButtonProps) => {
    return( 
        <Button
            onClick={onClick}
            type="button"
        >
            <CloseIcon color={colors.secondary.deepCove} />
        </Button> 
    );
};

export default CloseButton;